export default __webpack_public_path__ + "static/projector_w.161d9ca7c6f85d688f398f9360a11b96.svg";